<div class="cf_company">
	<search-bar
		[logoPath]="themeSettings.logoImgSrc"
		[searchOnFilterChange]="false"
		[navigateToResultsOnSearch]="true"
	>
	</search-bar>
	<div class="breadcrumbs-container">
		<breadcrumbs></breadcrumbs>
	</div>
	<div class="content">
		<!-- A StealthMode company should never be retrieved by an unauthenticated user, but to be safe, only show the indicator to authenticated users -->
		<div
			[ngClass]="{
				'stealthmode-background': true,
				'stealthmode-suppress': suppressStealthMode,
			}"
		></div>
		<div class="majorsection content-header">
			@if(isNew && !featureSwitches.enableShowCompanyLogos){
			<div class="new-company-indicator nologo">
				{{ Loc(LocalizedTextIds.New) }}
			</div>
			}
			<div class="top-row">
				<div class="company-logo">
					<company-logo [company]="company"></company-logo>
					@if(isNew && featureSwitches.enableShowCompanyLogos){
					<div class="new-company-indicator">
						{{ Loc(LocalizedTextIds.New) }}
					</div>
					}
				</div>
				<div
					[ngClass]="{
						'stealthmode-text': true,
						'stealthmode-suppress':
							suppressStealthMode,
					}"
				>
					{{ Loc(LocalizedTextIds.CompanyDetailsStealth) }}
				</div>
				<div class="action-wrapper">
					@if(isFollowEnabled && isInternalView){
					<div class="follow-section">
						<div
							class="follow-button"
							[ngClass]="{
								'is-following': isFollowing,
								'is-stealthmode': !suppressStealthMode,
							}"
							(click)="setFollowing(!isFollowing)"
						>
							<div class="header-button-label">
								{{
									isFollowing
										? Loc(LocalizedTextIds.Unfollow)
										: Loc(LocalizedTextIds.Follow)
								}}
								{{ Loc(LocalizedTextIds.Company) }}
							</div>
							<div class="icon"></div>
						</div>
					</div>
					} @if(isDownloadDocumentEnabled){
					<download #downloadButton [company]="company"></download>
					}
				</div>
			</div>
			<div class="grp1">
				<h1 class="name-label">
					{{ company.name }}
					<company-status-icon
						[statuses]="company.statuses"
						float="right"
						tooltipTop="32px"
						tooltipLeft="188px"
					></company-status-icon>
				</h1>
				@if(validCompanyWebsiteUrl) {
				<div class="url">
					<a href="{{ validCompanyWebsiteUrl }}" target="_blank">{{
						company.website
					}}</a>
				</div>
				}
				<status-list [statusItems]="statusItems"></status-list>
				@if(featureSwitches.enableShowLocationStatus){
				<company-location-status
					class="grp1-locationstatus"
					[company]="company"
					[useSeparator]="false"
					[singleLine]="false"
					[includeCompanyStatusRow]="false"
				>
				</company-location-status>
				}
				<div class="grp1-companysummary">
					<show-more-less
						[content]="company.description | nl2br"
						[maxHeight]="150"
						[lineHeight]="25"
					></show-more-less>
				</div>
				@if(featureSwitches.enableShowTags){
				<tags
					class="grp1-tags"
					[useWhiteBackground]="true"
					[marginTopForWrapping]="22"
					[targetIdentifier]="encodedName"
					[allowEliding]="false"
					[tags]="tagsSorted"
				>
				</tags>
				}
			</div>
			<div class="grp2">
				<div class="grp2-inner">
					<div class="sector-info">
						@if(showPrimaryAreaData){
						<div class="sector-group">
							<div class="title">
								{{ Loc(LocalizedTextIds.Primary) }}
							</div>
							<div class="sectors">
								<div class="headers">
									@if(primarySector) {
									<div class="header cell">
										{{ Loc(LocalizedTextIds.Sector) }}
									</div>
									} @if(company.primarySubSector?.length > 0)
									{
									<div class="header cell">
										{{ Loc(LocalizedTextIds.SubSector) }}
									</div>
									} @if(company.primaryIndication?.length > 0)
									{
									<div class="header cell">
										{{ Loc(LocalizedTextIds.Indication) }}
									</div>
									} @if(company.primarySectorDetail?.length >
									0) {
									<div class="header cell">
										{{ Loc(LocalizedTextIds.SectorDetail) }}
									</div>
									}
								</div>
								<div class="values">
									@if(primarySector) {
									<div class="cell elide">
										{{ primarySector }}
									</div>
									} @if(company.primarySubSector ?.length > 0)
									{
									<div class="cell elide">
										{{
											company.primarySubSector?.join(', ')
										}}
									</div>
									} @if(company.primaryIndication ?.length >
									0){
									<div class="cell elide">
										{{
											company.primaryIndication?.join(
												', '
											)
										}}
									</div>
									} @if(company.primarySectorDetail) {
									<div class="cell elide">
										{{ company.primarySectorDetail }}
									</div>
									}
								</div>
							</div>
						</div>
						} @if(showSecondaryAreaData){
						<div class="sector-group">
							<div class="title">
								{{ Loc(LocalizedTextIds.Secondary) }}
							</div>
							<div class="sectors">
								<div class="headers">
									@if(company.secondarySector) {
									<div class="header cell">
										{{ Loc(LocalizedTextIds.Sector) }}
									</div>
									} @if(company.secondarySubSector?.length >
									0) {
									<div class="header cell">
										{{ Loc(LocalizedTextIds.SubSector) }}
									</div>
									} @if(company.secondaryIndication ?.length >
									0){
									<div class="header cell">
										{{ Loc(LocalizedTextIds.Indication) }}
									</div>
									} @if(company.secondarySectorDetail) {
									<div class="header cell">
										{{ Loc(LocalizedTextIds.SectorDetail) }}
									</div>
									}
								</div>
								<div class="values">
									@if(company.secondarySector) {
									<div class="cell elide">
										{{ company.secondarySector }}
									</div>
									} @if(company.secondarySubSector?.length >
									0) {
									<div class="cell elide">
										{{
											company.secondarySubSector?.join(
												', '
											)
										}}
									</div>
									} @if(company.secondaryIndication ?.length >
									0){
									<div class="cell elide">
										{{
											company.secondaryIndication?.join(
												', '
											)
										}}
									</div>
									} @if(company.secondarySectorDetail){
									<div class="cell elide">
										{{ company.secondarySectorDetail }}
									</div>
									}
								</div>
							</div>
						</div>
						}
					</div>
					@if(showLeadProductStage){
					<div class="grp2-lead-product-stage">
						<div class="grp2-lead-product-stage-label">
							{{
								Loc(
									LocalizedTextIds.CompanyDetailsLeadProductStage
								)
							}}
						</div>
						<div class="grp2-lead-product-stage-content">
							{{ company.currentRdStage }}
						</div>
					</div>
					} @if(showStatus){
					<div class="grp2-status">
						<div class="grp2-status-container">
							@if(priority){
							<div class="grp2-status-container-priority">
								<div
									class="grp2-status-container-priority-icon"
								>
									<div [ngClass]="priorityClass"></div>
								</div>
								{{ priorityDisplay }}
							</div>
							@if(hasDealsWithJnJ) {
							<div
								class="grp2-status-container-dividingline-vertical"
							></div>
							} } @if(hasDealsWithJnJ) {
							<div class="grp2-status-container-dealwithjnj">
								<div
									class="grp2-status-container-dealwithjnj-icon"
								></div>
								{{ Loc(LocalizedTextIds.CompanyDetailsDeal) }}
							</div>
							}
						</div>
					</div>
					}
					<div class="grp2-contacts">
						@if(company.companyContact) {
						<div class="company-contact border-spec">
							<contact-component
								class="grp2-contacts-contact"
								[company]="company"
								[contacts]="company.companyContact"
								[role]="Loc(LocalizedTextIds.CompanyContact)"
								[showTitle]="true"
							></contact-component>
						</div>
						} @if(showAdditionalContacts){
						<div class="additional-contacts border-spec">
							<div class="two-columns">
								@if(showJpal) {
								<contact-component
									class="grp2-contacts-contact jpal"
									[company]="company"
									[contacts]="company.jpalContacts"
									[role]="Loc(LocalizedTextIds.JPAL)"
								>
								</contact-component
								>} @if(showSiteHead) {
								<contact-component
									class="grp2-contacts-contact"
									[company]="company"
									[contacts]="company.siteHead"
									[role]="Loc(LocalizedTextIds.SiteHead)"
								>
								</contact-component
								>}
							</div>
						</div>
						}
					</div>
				</div>
			</div>
		</div>

		<!-- If the only information we're showing is the public stuff, don't bother with the tab UI at all. -->
		@if (showSimpleTabUi) {
		<simple-tab-ui
			class="tabs"
			[tabs]="tabs"
			(tabClickEvent)="handleTabClick($event)"
		></simple-tab-ui>
		} @if(isShowingTabContent(TabConfigs.PUBLIC)) {
		<public-information [company]="company"></public-information>
		} @if(showInternalHeader) {
		<div class="internal-title">
			<div>{{ internalHeader }}</div>
			<div class="internal-subtitle">
				{{ internalSubtitle }}
			</div>
		</div>
		} @if(isShowingTabContent(TabConfigs.JNJ_ONLY)) {
		<jnj-information [company]="company" [assets]></jnj-information>
		}@else if(isShowingTabContent(TabConfigs.BLUE_KNIGHT)) {
		<blue-knight-information [company]="company"></blue-knight-information>
		}<!-- FUTURE -t his should be an else/if, but the linter is adding a line break 
				between if and else, which breaks the angular templating -->
		@if(isShowingTabContent(TabConfigs.BLUE_KNIGHT_MILESTONES)) {
		<blue-knight-milestones [company]="company"></blue-knight-milestones>
		}
	</div>
</div>
